// TODO replace with GraphQL type
import type {Detail as DetailData} from './data/types';

import DetailDescription from './DetailDescription';
import DetailSchedule from './DetailSchedule';
import DetailTextList from './DetailTextList';

import {SerializedStyles} from '@emotion/serialize';
import React from 'react';

export interface Props {
  readonly detail: DetailData;
  readonly style?: boolean | SerializedStyles;
}

export default function Detail(props: Props): JSX.Element {
  const {detail, style} = props;

  switch (detail.type) {
    case 'description':
      return (
        <DetailDescription
          description={detail}
          style={style}
        />
      );
    case 'list':
      return (
        <DetailTextList
          style={style}
          textList={detail}
        />
      );
    case 'schedule':
      return (
        <DetailSchedule
          schedule={detail}
          style={style}
        />
      );
    default:
      return <div />;
  }
}
